export enum AtiraSpacePlanPerksUsers {
  "PLAN_0" = 1,
  "PLAN_1" = 3,
  "PLAN_2" = 5,
}
